import { lazy } from 'react';
import type { RouteObject } from 'react-router';
const PersonalBrief=lazy(()=>import('./PersonalRecords').then(m=>({default:m.PersonalBrief})));
const PersonalCalendar=lazy(()=>import('./PersonalRecords').then(m=>({default:m.PersonalCalendar})));
const PersonalEvent=lazy(()=>import('./PersonalRecords').then(m=>({default:m.PersonalEvent})));
const Documents=lazy(()=>import('./Documents').then(m=>({default:m.Documents})));
const Threads=lazy(()=>import('@/mail/Threads').then(m=>({default:m.Threads})));
const ThreadPage=lazy(()=>import('@/mail/ThreadPage').then(m=>({default:m.ThreadPage})));
const Strangers=lazy(()=>import('@/mail/Strangers').then(m=>({default:m.Strangers})));
const Contacts=lazy(()=>import('@/directory/Directory').then(m=>({default:m.Contacts})));
const ContactPage=lazy(()=>import('@/directory/Records').then(m=>({default:m.ContactPage})));
const Companies=lazy(()=>import('@/directory/Directory').then(m=>({default:m.Companies})));
const CompanyPage=lazy(()=>import('@/directory/Records').then(m=>({default:m.CompanyPage})));
const Markets=lazy(()=>import('@/prospecting/Markets').then(m=>({default:m.Markets})));
const ReportDoc=lazy(()=>import('@/prospecting/ReportDoc').then(m=>({default:m.ReportDoc})));
const MarketPage=lazy(()=>import('@/prospecting/MarketPage').then(m=>({default:m.MarketPage})));
const Profiles=lazy(()=>import('@/prospecting/Profiles').then(m=>({default:m.Profiles})));
const ProfilePage=lazy(()=>import('@/prospecting/Profiles').then(m=>({default:m.ProfilePage})));
const Territories=lazy(()=>import('@/prospecting/Territories').then(m=>({default:m.Territories})));
const TerritoryPage=lazy(()=>import('@/prospecting/Territories').then(m=>({default:m.TerritoryPage})));
const ProspectingPlans=lazy(()=>import('@/prospecting/Plans').then(m=>({default:m.ProspectingPlans})));
const ProspectingPlanPage=lazy(()=>import('@/prospecting/Plans').then(m=>({default:m.ProspectingPlanPage})));
const Shortlists=lazy(()=>import('@/prospecting/Shortlists').then(m=>({default:m.Shortlists})));
const ShortlistPage=lazy(()=>import('@/prospecting/Shortlists').then(m=>({default:m.ShortlistPage})));
const Signals=lazy(()=>import('@/prospecting/Signals').then(m=>({default:m.Signals})));
const SignalPage=lazy(()=>import('@/prospecting/Records').then(m=>({default:m.SignalPage})));
const SetupProspecting=lazy(()=>import('@/prospecting/SetupProspecting').then(m=>({default:m.SetupProspecting})));
const ProfileChanges=lazy(()=>import('@/prospecting/FollowThrough').then(m=>({default:m.ProfileChanges})));
const ProfileChangePage=lazy(()=>import('@/prospecting/FollowThrough').then(m=>({default:m.ProfileChangePage})));
const Introductions=lazy(()=>import('@/prospecting/FollowThrough').then(m=>({default:m.Introductions})));
const IntroductionPage=lazy(()=>import('@/prospecting/Records').then(m=>({default:m.IntroductionPage})));
const Samples=lazy(()=>import('@/prospecting/FollowThrough').then(m=>({default:m.Samples})));
const OurIndex=lazy(()=>import('@/prospecting/FollowThrough').then(m=>({default:m.OurIndex})));
const IndexEntryPage=lazy(()=>import('@/prospecting/Records').then(m=>({default:m.IndexEntryPage})));
const Buyers=lazy(()=>import('@/validation/Validation').then(m=>({default:m.Buyers})));
const BuyerPage=lazy(()=>import('@/prospecting/Records').then(m=>({default:m.BuyerPage})));
const Suppliers=lazy(()=>import('@/validation/Validation').then(m=>({default:m.Suppliers})));
const SupplierPage=lazy(()=>import('@/validation/Validation').then(m=>({default:m.SupplierPage})));
const Offers=lazy(()=>import('@/validation/Validation').then(m=>({default:m.Offers})));
const OfferPage=lazy(()=>import('@/validation/Validation').then(m=>({default:m.OfferPage})));
const Suppression=lazy(()=>import('@/outreach/Suppression').then(m=>({default:m.Suppression})));
const Prospects=lazy(()=>import('@/outreach/Prospects').then(m=>({default:m.Prospects})));
const ProspectPage=lazy(()=>import('@/prospecting/ProspectPage').then(m=>({default:m.ProspectPage})));
const FirstTouches=lazy(()=>import('@/outreach/FirstTouches').then(m=>({default:m.FirstTouches})));
const Campaigns=lazy(()=>import('@/outreach/Campaigns').then(m=>({default:m.Campaigns})));
const Lifecycle=lazy(()=>import('@/outreach/Lifecycle').then(m=>({default:m.Lifecycle})));
const Mailings=lazy(()=>import('@/outreach/Mailings').then(m=>({default:m.Mailings})));
const OutreachReport=lazy(()=>import('@/outreach/OutreachReport').then(m=>({default:m.OutreachReport})));
const FlexList=lazy(()=>import('@/records/Flex').then(m=>({default:m.FlexList})));
const FlexRecord=lazy(()=>import('@/records/Flex').then(m=>({default:m.FlexRecord})));
const Requests=lazy(()=>import('@/requests/Requests').then(m=>({default:m.Requests})));
const RequestPage=lazy(()=>import('@/requests/RequestPage').then(m=>({default:m.RequestPage})));
const Activity=lazy(()=>import('@/requests/Activity').then(m=>({default:m.Activity})));
const Changes=lazy(()=>import('@/changes/Changes').then(m=>({default:m.Changes})));
const Projects=lazy(()=>import('@/projects/Projects').then(m=>({default:m.Projects})));
const ProjectPage=lazy(()=>import('@/projects/ProjectPage').then(m=>({default:m.ProjectPage})));
const ChangePage=lazy(()=>import('@/changes/ChangePage').then(m=>({default:m.ChangePage})));
const Tasks=lazy(()=>import('@/tasks/TaskPage').then(m=>({default:m.Tasks})));
const TaskRoute=lazy(()=>import('@/tasks/TaskPage').then(m=>({default:m.TaskRoute})));
const Approvals=lazy(()=>import('@/oversight/Approvals').then(m=>({default:m.Approvals})));
const Notifications=lazy(()=>import('@/notices/Notifications').then(m=>({default:m.Notifications})));
const Incidents=lazy(()=>import('@/notices/Incidents').then(m=>({default:m.Incidents})));
const IncidentPage=lazy(()=>import('@/notices/Incidents').then(m=>({default:m.IncidentPage})));
const Reports=lazy(()=>import('@/oversight/Reports').then(m=>({default:m.Reports})));
const Directions=lazy(()=>import('@/rules/Directions').then(m=>({default:m.Directions})));
const Registers=lazy(()=>import('@/rules/Registers').then(m=>({default:m.Registers})));
const Institutions=lazy(()=>import('@/institutions/Institutions').then(m=>({default:m.Institutions})));
const InstitutionPage=lazy(()=>import('@/institutions/Institutions').then(m=>({default:m.InstitutionPage})));
const Refusals=lazy(()=>import('@/ui/RefusalPage').then(m=>({default:m.Refusals})));
const Insight=lazy(()=>import('@/insight/Insight').then(m=>({default:m.Insight})));
const DepartmentDay=lazy(()=>import('./DepartmentDay').then(m=>({default:m.DepartmentDay})));
/** Shared domain views, loaded only when opened in Today. */
export const BUSINESS_ROUTES: RouteObject[]=[
 {path:'/today/department',element:<DepartmentDay />},
 {path:'/documents',element:<Documents />},
 {path:'/today/events/:id',element:<PersonalEvent />},
 {path:'/today/briefs/:id',element:<PersonalBrief />},
 {path:'/calendar',element:<PersonalCalendar />},
  {path: '/mail', element: <Threads />},
  {path: '/mail/shared', element: <Threads view="shared" />},
  {path: '/mail/mine', element: <Threads view="mine" />},
  {path: '/conversations', element: <Threads title="Conversations" />},
  {path: '/mail/:threadId', element: <ThreadPage />},
  {path: '/strangers', element: <Strangers />},
  {path: '/contacts', element: <Contacts />},
  {path: '/contacts/:id', element: <ContactPage />},
  {path: '/companies', element: <Companies />},
  {path: '/companies/:id', element: <CompanyPage />},
  {path: '/markets', element: <Markets />},
  {path: '/markets/report', element: <ReportDoc />},
  {path: '/markets/:code', element: <MarketPage />},
  {path: '/markets/:code/report', element: <ReportDoc />},
  {path: '/profiles', element: <Profiles />},
  {path: '/profiles/:id', element: <ProfilePage />},
  {path: '/territories', element: <Territories />},
  {path: '/territories/:id', element: <TerritoryPage />},
  {path: '/prospecting/plans', element: <ProspectingPlans />},
  {path: '/prospecting/plans/:id', element: <ProspectingPlanPage />},
  {path: '/prospecting/shortlists', element: <Shortlists />},
  {path: '/prospecting/shortlists/:id', element: <ShortlistPage />},
  {path: '/signals', element: <Signals />},
  {path: '/signals/:id', element: <SignalPage />},
  {path: '/prospecting/setup', element: <SetupProspecting />},
  {path: '/profile-changes', element: <ProfileChanges />},
  {path: '/profile-changes/:id', element: <ProfileChangePage />},
  {path: '/introductions', element: <Introductions />},
  {path: '/introductions/:id', element: <IntroductionPage />},
  {path: '/samples', element: <Samples />},
  {path: '/our-index', element: <OurIndex />},
  {path: '/our-index/:id', element: <IndexEntryPage />},
  {path: '/buyers', element: <Buyers />},
  {path: '/buyers/:id', element: <BuyerPage />},
  {path: '/suppliers', element: <Suppliers />},
  {path: '/suppliers/:id', element: <SupplierPage />},
  {path: '/offers', element: <Offers />},
  {path: '/offers/:id', element: <OfferPage />},
  {path: '/said-stop', element: <Suppression />},
  {path: '/prospects', element: <Prospects />},
  {path: '/prospects/:id', element: <ProspectPage />},
  {path: '/first-touches', element: <FirstTouches />},
  {path: '/campaigns', element: <Campaigns />},
  {path: '/lifecycle', element: <Lifecycle />},
  {path: '/mailings', element: <Mailings />},
  {path: '/outreach-report', element: <OutreachReport />},
  {path: '/records/:entity', element: <FlexList />},
  {path: '/records/:entity/:id', element: <FlexRecord />},
  {path: '/requests', element: <Requests />},
  {path: '/requests/:id', element: <RequestPage />},
  {path: '/activity', element: <Activity />},
  {path: '/changes', element: <Changes />},
  {path: '/projects', element: <Projects />},
  {path: '/projects/:id', element: <ProjectPage />},
  {path: '/changes/:id', element: <ChangePage />},
  {path: '/tasks', element: <Tasks />},
  {path: '/tasks/:taskId', element: <TaskRoute />},
  {path: '/approvals', element: <Approvals />},
  {path: '/notifications', element: <Notifications />},
  {path: '/incidents', element: <Incidents />},
  {path: '/incidents/:id', element: <IncidentPage />},
  {path: '/reports', element: <Reports />},
  {path: '/directions', element: <Directions />},
  {path: '/registers', element: <Registers />},
  {path: '/institutions', element: <Institutions />},
  {path: '/institutions/:id', element: <InstitutionPage />},
  {path: '/refusals', element: <Refusals />},
  {path: '/insight/:key', element: <Insight />}
];
